import { IGoodCreate } from "views/admin/goods/types/goods.interface";
import axiosInstance from "./config";

const basePath = `/induk-app/products`;

export const getGoods = (
  page?: number,
  order?: number,
  search?: string,
  limit?: number
) => {
  return axiosInstance.get(`${basePath}`, {
    params: {
      page,
      ob: order,
      search,
      limit,
    },
  });
};

export const addGood = (good: IGoodCreate) => {
  return axiosInstance.post(`${basePath}/create`, good);
};

export const getGood = (slug: string) => {
  return axiosInstance.get(`${basePath}/${slug}`);
};

export const updateGood = (slug: string, good: Partial<IGoodCreate>) => {
  return axiosInstance.patch(`${basePath}/${slug}/update`, good);
};

export const deleteGood = (slug: string) => {
  return axiosInstance.delete(`${basePath}/${slug}/delete`);
};

export const uploadGoodImages = (
  images: File[],
  uploadProgress: React.Dispatch<React.SetStateAction<number>>
) => {
  const formData = new FormData();
  images.forEach((image) => {
    formData.append("images", image);
  });
  return axiosInstance.post(`${basePath}/images-upload`, formData, {
    onUploadProgress(progressEvent) {
      uploadProgress(
        Math.floor((progressEvent.loaded * 100) / progressEvent.total)
      );
    },
  });
};

export const addGoodsCSV = (csv: File) => {
  const formData = new FormData();
  formData.append("file", csv);
  return axiosInstance.post(`${basePath}/create-with-csv`, formData);
};

export const assignGoodToBranch = (payload: {
  store_id: number;
  products: {
    product_id: number;
    stock: number;
  }[];
}) => {
  return axiosInstance.post(`/induk-app/assign-products/assign`, payload);
};

export const assignGoodsCSV = (store_id: number, csv: File) => {
  const formData = new FormData();
  formData.append("file", csv);
  formData.append("store_id", store_id.toString());
  return axiosInstance.post(`/induk-app/assign-products/assign-csv`, formData);
};

export const getBranchsAssignLists = (slug: string) => {
  return axiosInstance.get(`/induk-app/assign-products/store/${slug}`);
};

export const rollbackBranchStock = (slug: string, id: number) => {
  return axiosInstance.get(
    `/induk-app/assign-products/store/${slug}/${id}/rollback`
  );
};
